import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    label: 'Show my trade name',
  },
  fr: {
    label: 'Afficher mon nom commercial',
  },
} as const);

export default locales;
